import { Reveal } from "@/components/okaia/Reveal";

const PRIORITAIRES = [
  "Choisir un profil de client précis.",
  "Formuler le problème traité et le service proposé.",
  "Échanger avec quelques personnes correspondant à ce profil.",
];

const SUIVANTES = [
  "Ajuster la présentation de l'offre selon les retours.",
  "Préparer une page simple et un moyen de prise de contact.",
];

export const DiagnosticExample = () => (
  <section id="exemple" data-testid="section-exemple" className="bg-[#F9F8F6] py-16 md:py-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="border border-[#C8A97E]/50 p-8 md:p-12">
        <Reveal>
          <p className="okaia-overline mb-6 text-[#B39265]">
            Exemple illustratif — ce n'est pas un témoignage client
          </p>
          <h2 className="max-w-2xl font-serif-display text-3xl leading-[1.1] tracking-tight text-[#0B2215] md:text-4xl">
            À quoi ressemble la synthèse d'un diagnostic&nbsp;?
          </h2>
        </Reveal>
        <div className="mt-10 grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <p className="okaia-overline text-[#B39265]">Situation</p>
              <p className="mt-3 text-base font-light leading-relaxed text-[#4A5A52]">
                Un indépendant prépare son lancement, mais hésite entre créer son site, publier
                sur les réseaux sociaux et prospecter.
              </p>
              <p className="okaia-overline mt-8 text-[#B39265]">Priorité</p>
              <p className="mt-3 font-serif-display text-lg italic leading-snug text-[#0B2215] md:text-xl">
                Préciser son offre et vérifier qu'elle répond à un besoin.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.15}>
              <p className="okaia-overline text-[#B39265]">Trois actions prioritaires</p>
              <ol className="mt-3">
                {PRIORITAIRES.map((a, i) => (
                  <li key={i} data-testid={`example-action-${i + 1}`} className="flex items-start gap-4 border-b border-[#0B2215]/10 py-3 text-base font-light text-[#0B2215]">
                    <span className="font-serif-display text-sm italic text-[#C8A97E]">{i + 1}.</span>
                    {a}
                  </li>
                ))}
              </ol>
              <p className="okaia-overline mt-7 text-[#B39265]">Deux actions suivantes</p>
              <ol className="mt-3">
                {SUIVANTES.map((a, i) => (
                  <li key={i} data-testid={`example-action-${i + 4}`} className="flex items-start gap-4 border-b border-[#0B2215]/10 py-3 text-base font-light text-[#0B2215]">
                    <span className="font-serif-display text-sm italic text-[#C8A97E]">{i + 4}.</span>
                    {a}
                  </li>
                ))}
              </ol>
            </Reveal>
          </div>
        </div>
        <Reveal delay={0.2}>
          <p data-testid="example-note" className="mt-8 border-t border-[#0B2215]/10 pt-5 text-sm font-light italic text-[#4A5A52]">
            Les actions de votre diagnostic seront adaptées à votre propre situation.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
